<template src="@/templates/reservations/reservation.html"></template>

<script>
import userApi from '@/api/userApi';
import entityStore from '@/store/entityStore';

export default {
  props: [
    'reservationId',
  ],
  data() {
    return {
      reservation: {},
      isLoading: true,
      entity: entityStore.state,
    };
  },
  computed: {
    isPaid() {
      if (this.reservation.isPaid) {
        return this.reservation.isPaid;
      }
      return false;
    },
    showTravelDocuments() {
      return entityStore.state.name !== 'aircruise';
    },
    showTourleader() {
      return entityStore.state.name !== 'aircruise';
    },
    showParticipants() {
      const name = entityStore.state.name;
      return !(name === 'aircruise' || name === 'friendshipcruises' || this.reservation.reservation_type !== 'standard');
    },
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData();
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getReservation(this.reservationId, (data) => {
        this.reservation = data.reservation;
        this.isLoading = false;
      });
    },
    menuToggle(event) {
      $('.mobile-menu').slideToggle();
      $(event.target).toggleClass('active');
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// reservation.vue?3ad0d8e2